import { client } from './client';

// --- Credentials (nested under supplier) ---

export const getCredentialsBySupplier = async (supplierUid) => {
    const response = await client.get(`/v1/suppliers/${supplierUid}/credentials`);
    return response.data?.items ?? response.data;
};

export const getCredential = async (uid) => {
    const response = await client.get(`/v1/credentials/${uid}`);
    return response.data;
};

export const createCredential = async (supplierUid, data) => {
    const response = await client.post(`/v1/suppliers/${supplierUid}/credentials`, data);
    return response.data;
};

export const updateCredential = async (uid, data) => {
    const response = await client.put(`/v1/credentials/${uid}`, data);
    return response.data;
};

export const deleteCredential = async (uid) => {
    const response = await client.delete(`/v1/credentials/${uid}`);
    return response.data;
};
